import type React from 'react'
import { Vertical } from '@gravitate-js/excalibrr'

interface IProps {
  width?: number
  displayValue: () => JSX.Element
}
export const CustomHeaderTooltips: React.FC<IProps> = ({ width, displayValue }) => {
  return (
    <Vertical style={{ minWidth: width, maxWidth: width }} className={'bg-1 bordered p-2 px-3'}>
      {displayValue()}
    </Vertical>
  )
}
